// extracted by mini-css-extract-plugin
export var buttons = "_5i-0";
export var buttonsActive = "_5i-h";
export var cancelConfirm = "_5i-1";
export var closeButton = "_5i-2";
export var column = "_5i-3";
export var container = "_5i-4";
export var detailHeader = "_5i-6";
export var detailTitle = "_5i-7";
export var detailsContent = "_5i-5";
export var header = "_5i-8";
export var headerWithClose = "_5i-9";
export var icon = "_5i-a";
export var infoIcon = "_5i-c";
export var informationContainer = "_5i-b";
export var sideDrawer = "_5i-d";
export var sideDrawerOpen = "_5i-e";
export var stickyFooter = "_5i-f";
export var typeOption = "_5i-g";